import { isUsingKanji } from "./../actions/game.actions";
import { Book, Chapter, Question } from "./../../models/game";
import * as GameActions from "../actions/game.actions";
import { createReducer, on } from "@ngrx/store";
import { Game } from "src/app/models/game";
import { state } from "@angular/animations";

export interface GameState {
  books: Array<Book>;
  chapterDetails: Chapter;
  questions: Array<Question>;
  loaded: boolean;
  loading: boolean;
  gameDataError?: Error;
  isReviewingWrongAnswers: boolean;
  isUsingKanji: boolean;
  isUsingSound: boolean;
  studyMethod: string;
}

export const intializeState = (): GameState => {
  return {
    books: Array<Book>(),
    chapterDetails: null,
    loaded: false,
    loading: false,
    isReviewingWrongAnswers: false,
    questions: Array<Question>(),
    isUsingKanji: false,
    isUsingSound: true,
    studyMethod: "japaneseToEnglish",
  };
};

export const gameReducer = createReducer(
  intializeState(),
  // tslint:disable-next-line: no-shadowed-variable
  on(GameActions.getGameData, (state) => {
    return { ...state, loading: true };
  }),
  // tslint:disable-next-line: no-shadowed-variable
  on(GameActions.SuccessGetGameDataAction, (state: GameState, { payload }) => {
    return { ...state, books: payload, loading: false, loaded: true };
  }),
  // tslint:disable-next-line: no-shadowed-variable
  on(GameActions.ErrorGameDataAction, (state: GameState, error: Error) => {
    console.error(error);
    return { ...state, gameDataError: error };
  }),
  // tslint:disable-next-line: no-shadowed-variable
  on(GameActions.setGameQuestions, (state: GameState, { payload }) => {
    return { ...state, questions: payload };
  }),
  // tslint:disable-next-line: no-shadowed-variable
  on(GameActions.setChapterDetails, (state: GameState, { payload }) => {
    return { ...state, chapterDetails: payload };
  }),
  // tslint:disable-next-line: no-shadowed-variable
  on(GameActions.isReviewingWrongAnswers, (state: GameState) => {
    return { ...state, isReviewingWrongAnswers: true };
  }),
  // tslint:disable-next-line: no-shadowed-variable
  on(GameActions.notReviewingWrongAnswers, (state: GameState) => {
    return { ...state, isReviewingWrongAnswers: false };
  }),
  // tslint:disable-next-line: no-shadowed-variable
  on(GameActions.isUsingKanji, (state: GameState) => {
    return { ...state, isUsingKanji: true };
  }),
  // tslint:disable-next-line: no-shadowed-variable
  on(GameActions.notUsingKanji, (state: GameState) => {
    return { ...state, isUsingKanji: false };
  }),
  on(GameActions.isUsingSound, (state: GameState) => {
    return { ...state, isUsingSound: true };
  }),
  // tslint:disable-next-line: no-shadowed-variable
  on(GameActions.notUsingSound, (state: GameState) => {
    return { ...state, isUsingSound: false };
  }),
  // tslint:disable-next-line: no-shadowed-variable
  on(GameActions.playJapaneseToEnglish, (state: GameState) => {
    return { ...state, studyMethod: "japaneseToEnglish" };
  }),
  // tslint:disable-next-line: no-shadowed-variable
  on(GameActions.playEnglishToJapanese, (state: GameState) => {
    return { ...state, studyMethod: "englishToJapanese" };
  })
);
